class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[name="language_code"], input[name="country_code"]');
    this.button = this.querySelector('button');
    this.panel = this.querySelector('ul');
    if (!this.button || !this.panel) return;

    this.button.addEventListener('click', this.openSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    this.querySelectorAll('a').forEach((item) =>
      item.addEventListener('click', this.onItemClick.bind(this))
    );

    // закрытие по клику вне компонента (focusout не ловит клики по не-фокусируемым элементам)
    this._onDocClick = (event) => {
      if (this.button.getAttribute('aria-expanded') !== 'true') return;
      if (!this.contains(event.target)) this.hidePanel();
    };
    document.addEventListener('click', this._onDocClick);
  }

  disconnectedCallback() {
    if (this._onDocClick) document.removeEventListener('click', this._onDocClick);
  }

  hidePanel() {
    this.button.setAttribute('aria-expanded', 'false');
    this.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    this.hidePanel();
    this.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.button.focus();
    this.panel.toggleAttribute('hidden');
    this.button.setAttribute(
      'aria-expanded',
      (this.button.getAttribute('aria-expanded') === 'false').toString()
    );
  }
}

customElements.define('localization-form', LocalizationForm);
